import React from 'react'
import { Bullet, Bullets, Info, Page, Section } from '../../components/DocsComponents'
import DocLink from '../../components/DocLink'

const GovernanceAudits = () => (
  <Page
    title="Governance Audits"
    intro="Governance teams build reusable audit templates, staff complete audits against them, and the results feed an audit log and follow-up actions."
  >
    <Section title="Audit templates">
      <Bullets>
        <Bullet>
          Manage templates from{' '}
          <DocLink url="/governance/audit-templates" text="Audit Templates" />.
          A set of system templates is provided, and you can build your own.
        </Bullet>
        <Bullet>
          Each template has a category, a required frequency, required/active
          flags, and a list of questions - each question can carry guidance
          text and be marked required or optional.
        </Bullet>
      </Bullets>
    </Section>

    <Section title="Completing an audit">
      <Bullets>
        <Bullet>
          Complete an audit from{' '}
          <DocLink url="/governance/audit" text="Complete Audit" /> by
          choosing a template, then answering each question as compliant, not
          compliant, or not applicable, with an optional comment.
        </Bullet>
        <Bullet>
          Any answer can flag <strong>Action Required</strong> with a title,
          description, and due date - submitting the audit creates a
          governance action for each flagged answer.
        </Bullet>
        <Bullet>
          Review completed audits from{' '}
          <DocLink url="/governance/audits" text="Audit Log" />.
        </Bullet>
        <Bullet>
          Actions raised by audits are tracked through to completion in the
          governance actions register - see{' '}
          <DocLink
            docsPage
            url="/clinical-governance/governance-actions"
            text="Governance Actions"
          />
          .
        </Bullet>
      </Bullets>
      <Info title="Who can do this?">
        Any signed-in user can complete and submit an audit. Creating or
        editing templates and viewing the audit log require the Governance
        team (site administrators always have access). Governance audits are
        a tier 2 feature.
      </Info>
      <Info title="Medicines audits are separate">
        Drug bag audits and controlled drug audits are recorded in Medicines
        Management, not here - see{' '}
        <DocLink
          docsPage
          url="/clinical-governance/medicines-management"
          text="Medicines Management"
        />
        .
      </Info>
    </Section>
  </Page>
)

export default GovernanceAudits
